// Experiences carousel initialization
function initializeExperiencesCarousel(imageUrls) {
  console.group('🎠 Experiences Carousel Initialization');
  console.log('Function called with imageUrls:', imageUrls);
  console.log('Number of images:', imageUrls ? imageUrls.length : 0);
  
  // Check if ExperiencesApp is available
  if (typeof ExperiencesApp === 'undefined') {
    console.error('❌ ExperiencesApp is not defined');
    console.groupEnd();
    return;
  }
  
  console.log('✅ ExperiencesApp is available:', ExperiencesApp);
  
  // Check if carousel element exists
  const carouselElement = document.querySelector("#exp__carousel");
  console.log('Carousel element found:', carouselElement);
  
  if (!carouselElement) {
    console.warn('⚠️ Carousel element #exp__carousel not found in DOM');
  }
  
  try {
    console.log('🚀 Calling ExperiencesApp.enableCarousel with config:', {
      rootSelector: "#exp__carousel",
      imageUrls,
    });
    
    const result = ExperiencesApp.enableCarousel({
      rootSelector: "#exp__carousel",
      imageUrls,
    });
    
    console.log('✅ Carousel initialization result:', result);
    console.groupEnd();
    
    return result;
  } catch (error) {
    console.error('❌ Error initializing carousel:', error);
    console.groupEnd();
    throw error;
  }
}

// Book now button initialization and customization
function initializeBookNowButton(productId) {
  console.group('🎫 Book Now Button Initialization');
  console.log('Function called with productId:', productId);
  console.log('DOM ready state:', document.readyState);
  
  document.addEventListener("DOMContentLoaded", function() {
    console.log('📄 DOM Content Loaded event fired');
    console.log('Current timestamp:', new Date().toISOString());
    
    var target = document.getElementById("expapp-book-now-button");
    console.log('Target element found:', target);
    
    if (!target) {
      console.error('❌ Target element #expapp-book-now-button not found');
      console.groupEnd();
      return;
    }
    
    console.log('Target element attributes:', {
      id: target.id,
      className: target.className,
      dataset: target.dataset,
      innerHTML: target.innerHTML
    });
    
    if (target.dataset.expappMounted) {
      console.warn('⚠️ Button already mounted, skipping initialization');
      console.log('Existing dataset.expappMounted:', target.dataset.expappMounted);
      console.groupEnd();
      return;
    }
    
    console.log('🏷️ Setting expappMounted flag');
    target.dataset.expappMounted = true;

    // Check if ExperiencesShopify is available
    if (typeof ExperiencesShopify === 'undefined') {
      console.error('❌ ExperiencesShopify is not defined');
      console.groupEnd();
      return;
    }
    
    console.log('✅ ExperiencesShopify is available:', ExperiencesShopify);
    console.log('Available methods:', Object.keys(ExperiencesShopify));

    const mountConfig = {
      target: target,
      id: "expapp-book-now-button",
      productId: productId,
      previewFetchCount: 0,
    };
    
    console.log('🚀 Calling ExperiencesShopify.mountBookNowButton with config:', mountConfig);
    
    try {
      var checkResponse = ExperiencesShopify.mountBookNowButton(mountConfig);
      console.log('✅ Mount response:', checkResponse);
    } catch (error) {
      console.error('❌ Error mounting book now button:', error);
      console.groupEnd();
      return;
    }

    // Member price injection
    console.group('💰 Member Price Injection');
    (function(){
      var memberPrice = window.EXP_MEMBER_PRICE || "";
      console.log('Member price from window.EXP_MEMBER_PRICE:', memberPrice);
      console.log('Member price type:', typeof memberPrice);
      console.log('Member price length:', memberPrice.length);
      
      if (!memberPrice) {
        console.log('❌ No member price found, skipping injection');
        console.groupEnd();
        return;
      }

      console.log('✅ Member price found, setting up injection logic');

      function inject(){
        console.log('🔍 Attempting to inject member price...');
        
        const priceSelectors = '[data-testid="price"], [data-expapp="price"], .exp__price, .ea-price, .price, [class*="price"]';
        console.log('Looking for price elements with selectors:', priceSelectors);
        
        var valueNode = target.querySelector(priceSelectors);
        console.log('Price value node found:', valueNode);
        
        if (!valueNode) {
          console.log('❌ No price value node found');
          return false;
        }
        
        console.log('Price value node details:', {
          tagName: valueNode.tagName,
          className: valueNode.className,
          textContent: valueNode.textContent,
          innerHTML: valueNode.innerHTML
        });
        
        const existingMemberPriceBlock = target.querySelector(".exp-member-price-block");
        if (existingMemberPriceBlock) {
          console.log('⚠️ Member price block already exists:', existingMemberPriceBlock);
          return true;
        }

        console.log('🔍 Looking for label node...');
        var labelNode = null;
        const labelSelectors = "h1,h2,h3,h4,strong,b,.exp__header-label,[class*='label']";
        console.log('Label selectors:', labelSelectors);
        
        target.querySelectorAll(labelSelectors).forEach(function(el){
          console.log('Checking label element:', {
            tagName: el.tagName,
            className: el.className,
            textContent: el.textContent.trim().toLowerCase()
          });
          
          if (labelNode) return;
          if ((el.textContent || "").trim().toLowerCase() === "price") {
            labelNode = el;
            console.log('✅ Found matching label node:', el);
          }
        });

        console.log('Final label node:', labelNode);

        console.log('🏗️ Creating member price block...');
        var block = document.createElement("div");
        block.className = "exp-member-price-block";

        var clonedLabel = labelNode ? labelNode.cloneNode(true) : document.createElement("div");
        clonedLabel.textContent = "Member Price";
        clonedLabel.style.fontWeight = "bold";
        console.log('Created cloned label:', clonedLabel);

        var clonedValue = valueNode.cloneNode(true);
        clonedValue.textContent = memberPrice;
        console.log('Created cloned value:', clonedValue);

        block.appendChild(clonedLabel);
        block.appendChild(clonedValue);
        
        console.log('📍 Inserting member price block after value node...');
        valueNode.parentNode.insertBefore(block, valueNode.nextSibling);

        block.style.marginTop = "2px";
        block.style.marginBottom = "6px";
        
        console.log('✅ Member price block successfully injected:', block);
        console.log('Block position in DOM:', {
          previousSibling: block.previousSibling,
          nextSibling: block.nextSibling,
          parentNode: block.parentNode
        });

        return true;
      }

      console.log('🚀 Running initial injection attempt...');
      if (!inject()) {
        console.log('⏳ Initial injection failed, setting up MutationObserver...');
        var obs = new MutationObserver(function(mutations){ 
          console.log('🔄 MutationObserver triggered with mutations:', mutations.length);
          mutations.forEach(function(mutation) {
            console.log('Mutation details:', {
              type: mutation.type,
              target: mutation.target,
              addedNodes: mutation.addedNodes.length,
              removedNodes: mutation.removedNodes.length
            });
          });
          
          if (inject()) {
            console.log('✅ Injection successful via MutationObserver, disconnecting...');
            obs.disconnect();
          }
        });
        obs.observe(target, { childList: true, subtree: true });
        console.log('👀 MutationObserver set up and observing target');
      } else {
        console.log('✅ Initial injection successful');
      }
      
      console.groupEnd();
    })();

    // Modal member price replacement
    console.group('🎭 Modal Member Price Replacement');
    (function(){
      var memberPrice = window.EXP_MEMBER_PRICE || "";
      var customerIsMember = window.EXP_CUSTOMER_IS_MEMBER || false;
      
      console.log('Modal member price from window.EXP_MEMBER_PRICE:', memberPrice);
      console.log('Customer is member from window.EXP_CUSTOMER_IS_MEMBER:', customerIsMember);
      
      if (!memberPrice) {
        console.log('❌ No member price found for modal, skipping modal replacement');
        console.groupEnd();
        return;
      }

      if (!customerIsMember) {
        console.log('❌ Customer is not a member, skipping modal price replacement');
        console.groupEnd();
        return;
      }

      console.log('✅ Customer is a member and member price found, setting up modal replacement logic');

      // Function to update confirmation form totals
      function updateConfirmationTotals() {
        console.log('📋 Updating confirmation form totals with member pricing...');
        
        // Look for confirmation form
        const confirmationForm = document.querySelector('.expapp-confirmation');
        if (!confirmationForm) {
          console.log('❌ Confirmation form not found');
          return;
        }

        console.log('✅ Found confirmation form');

        // Update individual entry prices
        const entryPrices = confirmationForm.querySelectorAll('.expapp-order-overview-entry-price');
        console.log(`Found ${entryPrices.length} entry prices in confirmation`);
        
        let totalEntries = 0;
        entryPrices.forEach(function(priceElement, index) {
          console.log(`Updating entry price ${index}:`, priceElement.textContent);
          
          // Skip if already showing member price
          if (priceElement.textContent.trim() === memberPrice.trim()) {
            console.log(`⏭️ Entry ${index} already shows member price`);
            totalEntries++;
            return;
          }

          priceElement.textContent = memberPrice;
          console.log(`✅ Updated entry ${index} to member price`);
          totalEntries++;
        });

        // Update the total price
        const confirmationTotalElement = confirmationForm.querySelector('.expapp-order-overview-total-price');
        if (confirmationTotalElement && totalEntries > 0) {
          const memberPriceNumeric = parseFloat(memberPrice.replace(/[$,]/g, ''));
          const totalAmount = memberPriceNumeric * totalEntries;
          const formattedTotal = '$' + totalAmount.toFixed(2);
          
          confirmationTotalElement.textContent = formattedTotal;
          console.log(`✅ Updated confirmation total: ${totalEntries} × ${memberPrice} = ${formattedTotal}`);
        } else {
          console.log('❌ Confirmation total element not found or no entries');
        }
      }

      function replaceModalPrices() {
        console.log('🔍 Attempting to replace member prices in modal...');
        
        // Look for modal dialogs
        const modals = document.querySelectorAll('dialog.expapp-modal, .expapp-modal');
        console.log('Found modals:', modals.length);
        
        if (modals.length === 0) {
          console.log('❌ No modals found');
          return false;
        }

        let replaced = false;

        modals.forEach(function(modal, modalIndex) {
          console.log(`Processing modal ${modalIndex}:`, modal);
          
          // Skip if modal is not open/visible
          if (!modal.hasAttribute('open') && !modal.classList.contains('expapp-modal-open')) {
            console.log(`⏭️ Skipping modal ${modalIndex} - not open`);
            return;
          }

          console.log(`✅ Processing open modal ${modalIndex}`);

          // Look for timeslot prices (.expapp-timeslot-unit-price)
          const timeslotPrices = modal.querySelectorAll('.expapp-timeslot-unit-price');
          console.log(`Found ${timeslotPrices.length} timeslot prices in modal ${modalIndex}`);
          
          timeslotPrices.forEach(function(priceElement, priceIndex) {
            console.log(`Processing timeslot price ${priceIndex}:`, priceElement.textContent);
            
            // Check if already replaced (avoid replacing member price with member price)
            if (priceElement.textContent.trim() === memberPrice.trim()) {
              console.log(`⏭️ Price already replaced for timeslot ${priceIndex}`);
              return;
            }

            // Replace the price text
            priceElement.textContent = memberPrice;
            console.log(`✅ Replaced timeslot price ${priceIndex} with member price`);
            replaced = true;
          });

          // Look for variant prices (.expapp-variant-price)
          const variantPrices = modal.querySelectorAll('.expapp-variant-price');
          console.log(`Found ${variantPrices.length} variant prices in modal ${modalIndex}`);
          
          variantPrices.forEach(function(priceElement, priceIndex) {
            console.log(`Processing variant price ${priceIndex}:`, priceElement.textContent);
            
            // Check if already replaced
            if (priceElement.textContent.trim() === memberPrice.trim()) {
              console.log(`⏭️ Price already replaced for variant ${priceIndex}`);
              return;
            }

            // Replace the price text
            priceElement.textContent = memberPrice;
            console.log(`✅ Replaced variant price ${priceIndex} with member price`);
            replaced = true;
          });

          // Look for total prices (.expapp-variants-total-price, .expapp-order-overview-total-price)
          const totalPrices = modal.querySelectorAll('.expapp-variants-total-price, .expapp-order-overview-total-price, .expapp-order-overview-entry-price');
          console.log(`Found ${totalPrices.length} total/overview prices in modal ${modalIndex}`);
          
          totalPrices.forEach(function(priceElement, priceIndex) {
            console.log(`Processing total price ${priceIndex}:`, priceElement.textContent);
            
            // Skip if price is $0.00 (not selected yet)
            if (priceElement.textContent.trim() === '$0.00') {
              console.log(`⏭️ Skipping zero price for total ${priceIndex}`);
              return;
            }
            
            // Check if already replaced
            if (priceElement.textContent.trim() === memberPrice.trim()) {
              console.log(`⏭️ Price already replaced for total ${priceIndex}`);
              return;
            }

            // Replace the price text
            priceElement.textContent = memberPrice;
            console.log(`✅ Replaced total price ${priceIndex} with member price`);
            replaced = true;
          });

          // Set up quantity button event handlers for member pricing
          console.log('🔢 Setting up quantity button event handlers...');
          const decrementButtons = modal.querySelectorAll('.expapp-variant-count-decrement');
          const incrementButtons = modal.querySelectorAll('.expapp-variant-count-increment');
          
          console.log(`Found ${decrementButtons.length} decrement buttons and ${incrementButtons.length} increment buttons`);

          // Function to update total price based on quantity
          function updateTotalPrice() {
            console.log('💰 Updating total price with member pricing...');
            
            const quantityInput = modal.querySelector('.expapp-variant-count-input');
            const totalPriceElement = modal.querySelector('.expapp-variants-total-price');
            
            if (!quantityInput || !totalPriceElement) {
              console.log('❌ Quantity input or total price element not found');
              return;
            }

            const quantity = parseInt(quantityInput.value) || 0;
            console.log('Current quantity:', quantity);
            
            if (quantity === 0) {
              totalPriceElement.textContent = '$0.00';
              console.log('✅ Set total to $0.00 for zero quantity');
            } else {
              // Parse member price to get numeric value
              const memberPriceNumeric = parseFloat(memberPrice.replace(/[$,]/g, ''));
              const totalAmount = memberPriceNumeric * quantity;
              const formattedTotal = '$' + totalAmount.toFixed(2);
              
              totalPriceElement.textContent = formattedTotal;
              console.log(`✅ Updated total price: ${quantity} × ${memberPrice} = ${formattedTotal}`);
            }
          }

          // Add event listeners to decrement buttons
          decrementButtons.forEach(function(button, buttonIndex) {
            console.log(`Setting up decrement button ${buttonIndex}`);
            
            // Check if already has our event listener
            if (button.dataset.memberPriceListener) {
              console.log(`⏭️ Decrement button ${buttonIndex} already has listener`);
              return;
            }
            button.dataset.memberPriceListener = 'true';
            
            button.addEventListener('click', function(event) {
              console.log('🔽 Decrement button clicked');
              // Let the original event complete first
              setTimeout(function() {
                updateTotalPrice();
                updateConfirmationTotals();
              }, 50);
            });
          });

          // Add event listeners to increment buttons
          incrementButtons.forEach(function(button, buttonIndex) {
            console.log(`Setting up increment button ${buttonIndex}`);
            
            // Check if already has our event listener
            if (button.dataset.memberPriceListener) {
              console.log(`⏭️ Increment button ${buttonIndex} already has listener`);
              return;
            }
            button.dataset.memberPriceListener = 'true';
            
            button.addEventListener('click', function(event) {
              console.log('🔼 Increment button clicked');
              // Let the original event complete first
              setTimeout(function() {
                updateTotalPrice();
                updateConfirmationTotals();
              }, 50);
            });
          });

          // Also listen for direct input changes
          const quantityInputs = modal.querySelectorAll('.expapp-variant-count-input');
          quantityInputs.forEach(function(input, inputIndex) {
            console.log(`Setting up quantity input ${inputIndex}`);
            
            // Check if already has our event listener
            if (input.dataset.memberPriceListener) {
              console.log(`⏭️ Quantity input ${inputIndex} already has listener`);
              return;
            }
            input.dataset.memberPriceListener = 'true';
            
            input.addEventListener('input', function(event) {
              console.log('📝 Quantity input changed');
              setTimeout(function() {
                updateTotalPrice();
                updateConfirmationTotals();
              }, 50);
            });

            input.addEventListener('change', function(event) {
              console.log('📝 Quantity input change event');
              setTimeout(function() {
                updateTotalPrice();
                updateConfirmationTotals();
              }, 50);
            });
          });

          // Update button text from "Book it" to "Add to cart"
          console.log('🔘 Updating button text in modal...');
          const continueButtons = modal.querySelectorAll('.expapp-button-continue');
          console.log(`Found ${continueButtons.length} continue buttons in modal ${modalIndex}`);
          
          continueButtons.forEach(function(btn, btnIndex) {
            console.log(`Processing continue button ${btnIndex}:`, btn.textContent.trim());
            
            if (btn.textContent.trim().toLowerCase() === 'book it') {
              btn.textContent = 'Add to cart';
              console.log(`✅ Updated button ${btnIndex} text to "Add to cart"`);
              replaced = true;
            } else {
              console.log(`⏭️ Button ${btnIndex} text is not "Book it", skipping`);
            }
          });
        });

        console.log('Modal replacement completed. Replaced:', replaced);
        return replaced;
      }

      // Set up a global observer to watch for modal changes
      console.log('🚀 Setting up global modal observer...');
      const modalObserver = new MutationObserver(function(mutations) {
        console.log('🔄 Modal MutationObserver triggered with mutations:', mutations.length);
        
        let shouldReplace = false;
        
        mutations.forEach(function(mutation) {
          // Check if any modals were added or modified
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // Check if the added node is a modal or contains modals
                if (node.matches && (node.matches('dialog.expapp-modal') || node.querySelector('dialog.expapp-modal'))) {
                  console.log('🎭 Modal added to DOM:', node);
                  shouldReplace = true;
                }
                // Check for modal content changes
                if (node.matches && (node.matches('.expapp-timeslot') || node.matches('.expapp-variant') || node.matches('.expapp-order-overview') || node.matches('.expapp-confirmation'))) {
                  console.log('💰 Modal price content added:', node);
                  shouldReplace = true;
                }
              }
            });
          }
          
          // Check for attribute changes (like modal opening)
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            console.log('🎭 Modal open attribute changed:', mutation.target);
            shouldReplace = true;
          }
        });
        
        if (shouldReplace) {
          console.log('🚀 Triggering modal price replacement...');
          setTimeout(function() {
            replaceModalPrices();
            // Also check for confirmation form updates
            setTimeout(function() {
              const confirmationForm = document.querySelector('.expapp-confirmation');
              if (confirmationForm) {
                console.log('📋 Found confirmation form, updating totals...');
                updateConfirmationTotals();
              }
            }, 200);
          }, 100); // Small delay to ensure content is rendered
        }
      });

      // Observe the entire document for modal changes
      modalObserver.observe(document.body, { 
        childList: true, 
        subtree: true, 
        attributes: true,
        attributeFilter: ['open', 'class']
      });
      console.log('👀 Global modal observer set up and observing document.body');

      // Run initial replacement in case modals are already present
      console.log('🚀 Running initial modal replacement attempt...');
      replaceModalPrices();
      
      console.groupEnd();
    })();

    // Button styling and functionality updates
    console.group('🎨 Button Styling and Functionality Updates');
    (function(){
      function update(){
        console.log('🔄 Running update function...');
        
        var rows = target.querySelectorAll('div');
        console.log('Found div rows:', rows.length);
        
        var processed = false;
        var locationLabel = null;
        var locationValue = null;

        console.log('🔍 Looking for non-member disable button...');
        const nonMemberDisableButton = document.querySelector('.expapp-book-nonmember-disable button.expapp-booknow-button');
        if (nonMemberDisableButton) {
          console.log('✅ Found non-member disable button:', nonMemberDisableButton);
          const buttonSpan = nonMemberDisableButton.querySelector('span');
          if (buttonSpan) {
            console.log('📝 Updating button text to "Members only"');
            buttonSpan.textContent = 'Members only';
          }
          console.log('🚫 Disabling button');
          nonMemberDisableButton.disabled = true;
        } else {
          console.log('❌ Non-member disable button not found');
        }

        console.log('🔍 Processing rows...');
        rows.forEach(function(row, index){
          console.log(`Processing row ${index}:`, {
            element: row,
            children: row.children.length,
            className: row.className,
            textContent: row.textContent.trim()
          });
          
          if (row.children.length !== 2) {
            console.log(`⏭️ Skipping row ${index} - doesn't have exactly 2 children`);
            return;
          }
          
          var label = row.children[0];
          var value = row.children[1];
          
          if (!label || !value) {
            console.log(`⏭️ Skipping row ${index} - missing label or value`);
            return;
          }

          var labelText = label.textContent.trim();
          console.log(`Row ${index} label text:`, labelText);

          if (labelText === 'Location') {
            console.log('📍 Found Location row, capturing styles...');
            locationLabel = getComputedStyle(label);
            locationValue = getComputedStyle(value);
            console.log('Location label styles:', {
              fontSize: locationLabel.fontSize,
              lineHeight: locationLabel.lineHeight,
              fontWeight: locationLabel.fontWeight
            });
            console.log('Location value styles:', {
              fontSize: locationValue.fontSize,
              lineHeight: locationValue.lineHeight
            });
          }

          console.log(`🎨 Styling row ${index} label...`);
          label.style.fontWeight = 'bold';
          row.style.marginBottom = '6px';
          processed = true;
        });

        if (locationLabel && locationValue) {
          console.log('🎨 Applying consistent styling based on Location row...');
          rows.forEach(function(row, index){
            if (row.children.length !== 2) return;
            var label = row.children[0];
            var value = row.children[1];
            var labelText = label.textContent.trim();

            console.log(`Applying styles to row ${index} (${labelText})...`);

            if (labelText !== 'Location') {
              label.style.fontSize = locationLabel.fontSize;
              label.style.lineHeight = locationLabel.lineHeight;
              value.style.fontSize = locationValue.fontSize;
              value.style.lineHeight = locationValue.lineHeight;
              console.log(`✅ Applied consistent styles to ${labelText} row`);
            }

            if (labelText === 'Location') {
              console.log('🔗 Processing Location row links...');
              var links = value.querySelectorAll('a');
              console.log('Found links in Location:', links.length);
              
              links.forEach(function(link, linkIndex){
                console.log(`Setting up hover effects for link ${linkIndex}:`, link.href);
                link.style.transition = 'color 0.2s ease';
                link.addEventListener('mouseenter', function() {
                  console.log('🖱️ Mouse enter on location link');
                  this.style.color = '#2f5e44';
                });
                link.addEventListener('mouseleave', function() {
                  console.log('🖱️ Mouse leave on location link');
                  this.style.color = '';
                });
              });

              var valueText = value.textContent.trim();
              console.log('Location value text:', valueText);
              if (valueText === '') {
                console.log('🙈 Hiding empty Location row');
                row.style.display = 'none';
              }
            }
          });
        } else {
          console.log('⚠️ Location styles not captured, skipping consistent styling');
        }

        console.log('Update function completed. Processed:', processed);
        return processed;
      }

      function run(){
        console.log('🚀 Running styling function...');
        if (update()) {
          console.log('✅ Initial update successful');
          return;
        }

        console.log('⏳ Initial update failed, setting up MutationObserver...');
        var observer = new MutationObserver(function(mutations){
          console.log('🔄 Styling MutationObserver triggered with mutations:', mutations.length);
          mutations.forEach(function(mutation) {
            console.log('Styling mutation details:', {
              type: mutation.type,
              target: mutation.target,
              addedNodes: mutation.addedNodes.length,
              removedNodes: mutation.removedNodes.length
            });
          });
          
          if (update()) {
            console.log('✅ Update successful via MutationObserver, disconnecting...');
            observer.disconnect();
          }
        });
        observer.observe(target, { childList: true, subtree: true });
        console.log('👀 Styling MutationObserver set up and observing target');
      }

      run();
      console.groupEnd();
    })();
    
    console.log('🎫 Book Now Button initialization completed');
    console.groupEnd();
  });
}